document.addEventListener('DOMContentLoaded', function () {
	var btn = document.querySelector('#document-loadmore-btn')
	if (!btn) return

	btn.addEventListener('click', function () {
		if (btn.dataset.loading === 'true') return
		btn.dataset.loading = 'true'
		btn.disabled = true
		var label = btn.querySelector('.btn-label')
		var originalLabel = label ? label.textContent : ''
		if (label) label.textContent = 'Đang tải...'

		var url = btn.dataset.url
		var page = parseInt(btn.dataset.page, 10)
		var length = parseInt(btn.dataset.length, 10)
		var params = new URLSearchParams(btn.dataset.qs || '')
		params.set('page', page)

		fetch(url + '?' + params.toString())
			.then(function (res) {
				return res.text()
			})
			.then(function (html) {
				var container = document.querySelector('#document-rows')
				var temp = document.createElement(container.tagName === 'TBODY' ? 'tbody' : 'div')
				temp.innerHTML = html
				var items = Array.prototype.slice.call(temp.children)
				items.forEach(function (item) {
					container.appendChild(item)
				})
				if (items.length < length) {
					btn.closest('div').remove()
				} else {
					btn.dataset.page = page + 1
					btn.dataset.loading = 'false'
					btn.disabled = false
					if (label) label.textContent = originalLabel
				}
			})
			.catch(function (err) {
				console.log('document-loadmore error', err)
				btn.dataset.loading = 'false'
				btn.disabled = false
				if (label) label.textContent = originalLabel
			})
	})
})
